const initialState = {
  accessToken: null,
  user: null,
};

const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        accessToken: action.payload.accessToken,
        user: action.payload.user,
      };

    case "REFRESH_TOKEN":
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };

    case "REMOVE_TOKEN":
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      return {
        accessToken: null,
        user: null,
      };

    default:
      return state;
  }
};

export default tokenReducer;